<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1"><a href="#/5chap1#chap1">Shortchange</a></p>
<p class="toc1"><a href="#/6chap2#chap2">Hard Down the Middle</a></p>
<p class="toc1"><a href="#/7chap3#chap3">Community</a></p>
<p class="toc1"><a href="#/8chap4#chap4">Snap Crackle Pop</a></p>
<p class="toc1"><a href="#/9chap5#chap5">Seventeen Squared</a></p>
<p class="toc1"><a href="#/10chap6#chap6">Sting</a></p>
<p class="toc1"><a href="#/11chap7#chap7">Girl 17</a></p>
<p class="toc1"><a href="#/12chap8#chap8">Mulligatawny Soup</a></p>
<p class="toc1"><a href="#/13chap9#chap9">Winter Haven</a></p>
<p class="toc1"><a href="#/14chap10#chap10">Foreign Territory</a></p>
<p class="toc1"><a href="#/15chap11#chap11">Not Cricket</a></p>
<p class="toc1"><a href="#/16chap12#chap12">There but Not There</a></p>
<p class="toc1"><a href="#/17chap13#chap13">Gone Bananas</a></p>
<p class="toc1"><a href="#/18chap14#chap14">Impossible Dream</a></p>
<p class="toc1"><a href="#/19chap15#chap15">Real Spring</a></p>
<p class="toc1"><a href="#/20chap16#chap16">Yard Dogs</a></p>
<p class="toc1"><a href="#/21chap17#chap17">A Higher Calling</a></p>
<p class="toc1"><a href="#/22chap18#chap18">Gold Dust</a></p>
<p class="toc1"><a href="#/23chap19#chap19">I Swear</a></p>
<p class="toc1"><a href="#/24bio#bio">A Biography of Chris Lynch</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?80116622